import React from 'react';
import { BoxImage, CTAButton } from './CTAButton';
import { offerBullets } from '../data/content';
export function Offer() {
  return <section id="offer" className="scroll-mt-2 bg-navy px-3 py-4 sm:px-6" data-id="element-112" data-mp="17y3668my5u41">
      <div className="mx-auto max-w-xl text-center" data-id="element-113" data-mp="1mmh6ocww56hf">
        <p className="inline-block rounded-full bg-gold px-3 py-0.5 text-[0.66rem] font-extrabold uppercase tracking-[0.2em] text-navy sm:text-xs" data-id="element-114" data-mp="1mpd5e3gkbz6x">
          Special launch offer
        </p>
        <h2 className="mt-1.5 text-[1.25rem] font-extrabold uppercase leading-tight text-white sm:text-[1.9rem]" data-id="element-115" data-mp="u0xvfvcag72g">
          🩻 ULTRASOUND VISUAL ATLAS™
        </h2>
        <p className="mt-0.5 text-[0.7rem] font-bold uppercase tracking-wide text-white/80 sm:text-[0.84rem]" data-id="element-116" data-mp="13xsovztpfh9v">
          The Complete Visual Study System for Ultrasound Students
        </p>

        <BoxImage className="mx-auto mt-2 max-w-[240px] sm:max-w-[290px]" target="checkout" data-id="element-117" data-mp="2fb504vrsn262" />

        <div className="mt-2 rounded-md border-2 border-gold bg-white px-3 py-2.5 text-left" data-id="element-118" data-mp="2actnyee10fko">
          <p className="text-center text-[0.72rem] font-extrabold uppercase tracking-wide text-navy sm:text-[0.86rem]" data-id="element-119" data-mp="pjp8ru1dymmr">
            Complete 6-in-1 System
          </p>
          <ul className="mt-1.5 grid gap-1 sm:grid-cols-2" data-id="element-120" data-mp="zi53e6zmge10">
            {offerBullets.map(b => <li key={b} className="flex items-start gap-1.5" data-id="element-121" data-mp="13iyqwz95jqtd">
                <span className="text-[0.7rem] leading-tight" aria-hidden="true" data-id="element-122" data-mp="6tps9vjm2fuy">
                  ✅
                </span>
                <span className="text-[0.75rem] leading-tight sm:text-[0.86rem]" data-id="element-123" data-mp="bs10k1u9cib2">
                  {b}
                </span>
              </li>)}
          </ul>
          <p className="mt-2 text-center text-[0.8rem] font-extrabold uppercase leading-tight text-navy sm:text-[1rem]" data-id="element-124" data-mp="kl4a3z1s8b0f">
            🔥 GET ULTRASOUND VISUAL ATLAS™ TODAY —{' '}
            <span className="text-teal" data-id="element-125" data-mp="3k6jcienbkhzy">$26.90</span>
          </p>
          <div className="mt-1.5" data-id="element-126" data-mp="3o8whv1y5mdw7">
            <CTAButton label="⚡ GET INSTANT ACCESS" sub="Immediate Digital Access" target="checkout" data-id="element-127" data-mp="3o7utxww1hwx2" />
          </div>
          <p className="mt-1.5 text-center text-[0.62rem] font-bold uppercase tracking-wide sm:text-xs" data-id="element-128" data-mp="qg4jfrj9zuiv">
            🛡️ 7-Day Money-Back Guarantee
          </p>
        </div>
      </div>
    </section>;
}